import * as actions from "../actions/types";
import {NEW_USER} from "../actions/types";
import {LOGOUT_USER} from "../actions/types";

const initialState = {
    isFetching: false,
    data: [],
    message: null,
    failed: false,
}

export default function(state = initialState, action) {
    switch (action.type) {
        case actions.LOAD_STATUS:
            return {
                ...state,
                isFetching: true,
                failed: false,
            }
        case actions.LOAD_STATUS_FAILURE:
            return {
                ...state,
                isFetching: false,
                failed: true,
                message: action.message
            }
        case actions.LOAD_STATUS_SUCCESS:
            return {
                ...state,
                data: action.data,
                message: null,
                failed: false,
                isFetching: false,
            }
        default:
            return state;
    }
}